/* eslint-disable react/react-in-jsx-scope */
import { i18n } from 'i18next';
import { store } from 'redux/store';
import actionTypes from 'constants/actionTypes';

import AddBoard from 'modules/_shared/components/Modals/AddBoard';

import { setModal } from 'modules/_shared/redux/modalActions';
import { Board } from 'types';

type ActionOption = {
  icon: string;
  text: string;
  action: (params: any) => void; // eslint-disable-line no-unused-vars
  dropdown: boolean;
  dontShowCurrent: (params: any) => boolean; // eslint-disable-line no-unused-vars
};

const handleEditBoard = (currentBoard: Board) => {
  store.dispatch(
    setModal(<AddBoard action={actionTypes.EDIT} board={currentBoard} />)
  );
};

const actionOptions = (i18n: i18n): ActionOption[] => [
  {
    icon: 'ni-edit',
    text: i18n.t('Edit'),
    action: ({ currentBoard }) => {
      handleEditBoard(currentBoard);
    },
    dropdown: true,
    dontShowCurrent: ({ isEditButtonEnabled }) => !isEditButtonEnabled(),
  },
  {
    icon: 'ni-send',
    text: i18n.t('SendAnnouncement'),
    action: ({ handleSendAnnouncement }) => {
      handleSendAnnouncement();
    },
    dropdown: true,
    dontShowCurrent: ({ isSendButtonEnabled, currentBoard }) =>
      !isSendButtonEnabled() || currentBoard?.announcementComm,
  },
  {
    icon: 'ni-send',
    text: i18n.t('SendReminder'),
    action: ({ handleSendReminder }) => {
      handleSendReminder();
    },
    dropdown: true,
    dontShowCurrent: ({ isSendButtonEnabled, currentBoard }) =>
      !isSendButtonEnabled() || !currentBoard?.announcementComm,
  },
  {
    icon: 'ni-na',
    text: i18n.t('CloseBoard'),
    action: ({ handleCloseBoard }) => {
      handleCloseBoard();
    },
    dropdown: true,
    dontShowCurrent: ({ isCloseButtonEnabled }) => !isCloseButtonEnabled(),
  },
];

export default actionOptions;
